import React from 'react';
import Header from './Header';
import Footer from './Footer';
import { SocialLogin, TermsAndConditions  } from 'src/viewLayer/components/shared/SharedViewComponent';
import { useAppConfigContext } from 'src/viewLayer/components/contexts/AppConfigContext';

import './index.scss';

const WebCardLayout = ({
  appType,
  title,
  subtitle,
  BackgroundItems,
  Image,
  hideTermsAndConditions = false,
  children
}) => (
  <div className="CardLayoutComponent">
    <div className="CardLayout-card">
      <div className="CardLayout-container">
        <Header Image={Image} title={title} subtitle={subtitle} />
        {children}
        <SocialLogin appType={appType} />
      </div>
      { !hideTermsAndConditions && <TermsAndConditions /> }
    </div>
    <div className="CardLayout-bg-items">
      {BackgroundItems && BackgroundItems.map((BackgroundItem, index) => (
        <BackgroundItem key={index} />
      ))}
    </div>
    <Footer />
  </div>
);

const NativeMobileCardLayout = ({ title, subtitle, Image, children }) => (
  <div className="CardLayoutComponent">
    <div className="CardLayout-card login-mobile">
      <div className="CardLayout-container">
        <Header Image={Image} title={title} subtitle={subtitle} />
        {children}
      </div>
    </div>
  </div>
);

export default (props) => {
  const { devicePath } = useAppConfigContext();
  return (
    devicePath === 'login' ? <WebCardLayout {...props} /> : <NativeMobileCardLayout {...props} />
  );
};
